import { LiveForm } from 'components/secondaryMarket/live/liveForm';
import { formConnectFactory } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/shared/Form.connect';
import { connect } from 'react-redux';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';

const { mapStateToProps, mapDispatchToProps } = formConnectFactory(liveReferentialSelectors, liveSelectors, liveThunks);

export const ConnectedLiveForm = connect(mapStateToProps, mapDispatchToProps)(LiveForm);
